<template>
  <div class="row tabs">
    <div class="tab" v-for="(item, index) in tabs" :key="index"
      :class="{'active': index === activeIndex}" 
      @click="onTabClick(item, index)">{{item}}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tabs: {
      type: Array,
      default: () => []
    },
    activeTabIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      activeIndex: 0
    };
  },
  methods: {
    onTabClick(item, index) {
      this.activeIndex = index;
      this.$emit('change', {
        item,
        index
      });
    }
  },
  mounted() {
    this.activeIndex = this.activeTabIndex;
  }
};
</script>

<style lang="scss" scoped>
.tabs { 
  border:1px solid rgba(81,78,82,1);
  overflow: hidden;
  .tab {
    padding: 3px 12px;
    font-size: 14px;
    color: rgba(255, 255, 255, 0.7);
    cursor: pointer;
    &.active {
      color: #ffffff;
      font-weight: 500;
      background-color: #45a8cc;
    }
  }
}
</style>

